const textDefaults = {
	'EN': {
		'welcomeTitle': 'We need to scan some documents',
		'welcomeReason': 'The next page will guide you through this process.',
		'scanningTitle': 'Upload your documents',
		'scanningText': 'Capture or select an image of your document where the edges are visible and all text is clearly readable.',
		'errorNotRecognised': 'Document not recognized',
		'errorWrongType': 'This document is not recognized as {expectedType}. Please upload the correct document or a clear image of the document.',
		'errorUnsupportedClass': 'We couldn\'t verify this image. Please upload the front side of the requested document.',
		'feedbackReview': 'Provisionally accepted, pending review',
		'lblCountry': 'Country',
		'lblExpires': 'Expires',
		'lblUploadOrCapture': 'Upload or take a picture',
		'docTypesAny': 'ID Card or similar',
		'expiredError': 'Document expired or will expire too soon',
	},
	'FR': {
		'welcomeTitle': 'Nous devons scanner des documents',
		'welcomeReason': 'La page suivante vous guidera à travers ce processus.',
		'scanningTitle': 'Téléchargez vos documents',
		'scanningText': 'Prenez ou sélectionnez une image de votre document où les bords sont visibles et tout le texte est clairement lisible.',
		'errorNotRecognised': 'Document non reconnu',
		'errorWrongType': 'Ce document n\'est pas reconnu comme {expectedType}. Veuillez télécharger le document correct ou une image claire du document.',
		'errorUnsupportedClass': 'Nous n\'avons pas pu vérifier cette image. Veuillez télécharger le recto du document demandé.',
		'feedbackReview': 'Accepté provisoirement, en attente de révision',
		'lblCountry': 'Pays',
		'lblExpires': 'Expire',
		'lblUploadOrCapture': 'Téléchargez ou prenez une photo',
		'docTypesAny': 'Carte d’identité ou similaire',
		'expiredError': 'Document expiré ou expirera trop rapidement',
	},
	'DE': {
		'welcomeTitle': 'Wir müssen einige Dokumente scannen',
		'welcomeReason': 'Die nächste Seite wird Sie durch diesen Prozess führen.',
		'scanningTitle': 'Laden Sie Ihre Dokumente hoch',
		'scanningText': 'Erfassen oder wählen Sie ein Bild Ihres Dokuments, bei dem die Ränder sichtbar sind und der gesamte Text gut lesbar ist.',
		'errorNotRecognised': 'Dokument nicht erkannt',
		'errorWrongType': 'Dieses Dokument wird nicht als {expectedType} erkannt. Bitte laden Sie das korrekte Dokument oder ein klares Bild des Dokuments hoch.',
		'errorUnsupportedClass': 'Wir konnten dieses Bild nicht verifizieren. Bitte laden Sie die Vorderseite des angeforderten Dokuments hoch.',
		'feedbackReview': 'Vorläufig akzeptiert, ausstehende Überprüfung',
		'lblCountry': 'Land',
		'lblExpires': 'Läuft ab',
		'lblUploadOrCapture': 'Hochladen oder ein Bild aufnehmen',
		'docTypesAny': 'Personalausweis oder ähnliches',
		'expiredError': 'Dokument verloren oder wird zu bald ablaufen',
	},
	'NL': {
		'welcomeTitle': 'We moeten enkele documenten scannen',
		'welcomeReason': 'De volgende pagina leidt u door dit proces.',
		'scanningTitle': 'Upload uw documenten',
		'scanningText': 'Maak of selecteer een afbeelding van uw document waarbij de randen zichtbaar zijn en alle tekst goed leesbaar is.',
		'errorNotRecognised': 'Document niet herkend',
		'errorWrongType': 'Dit document wordt niet herkend als {expectedType}. Upload het juiste document of een duidelijke afbeelding van het document.',
		'errorUnsupportedClass': 'We konden deze afbeelding niet verifiëren. Upload de voorkant van het gevraagde document.',
		'feedbackReview': 'Voorlopig geaccepteerd, in afwachting van beoordeling',
		'lblCountry': 'Land',
		'lblExpires': 'Verloopt',
		'lblUploadOrCapture': 'Upload of maak een foto',
		'docTypesAny': 'ID-kaart of soortgelijk',
		'expiredError': 'Document verlopen of zal te snel verlopen',
	},
	'PL': {
		'welcomeTitle': 'Musimy zeskanować dokumenty',
		'welcomeReason': 'Następna strona poprowadzi Cię przez ten proces.',
		'scanningTitle': 'Prześlij swoje dokumenty',
		'scanningText': 'Zrób lub wybierz zdjęcie dokumentu, na którym krawędzie są widoczne, a cały tekst jest czytelny.',
		'errorNotRecognised': 'Dokument nierozpoznany',
		'errorWrongType': 'Ten dokument nie jest rozpoznawany jako {expectedType}. Proszę przesłać właściwy dokument lub wyraźne zdjęcie dokumentu.',
		'errorUnsupportedClass': 'Nie mogliśmy zweryfikować tego obrazu. Proszę przesłać przód żądanego dokumentu.',
		'feedbackReview': 'Tymczasowo zaakceptowano, w oczekiwaniu na weryfikację',
		'lblCountry': 'Kraj',
		'lblExpires': 'Wygasa',
		'lblUploadOrCapture': 'Prześlij lub zrób zdjęcie',
		'docTypesAny': 'Dowód osobisty lub podobny',
		'expiredError': 'Dokument wygasł lub wygaśnie za krótko',
	},
	'BG': {
		'welcomeTitle': 'Трябва да сканираме документи',
		'welcomeReason': 'Следващата страница ще ви насочи през този процес.',
		'scanningTitle': 'Качете вашите документи',
		'scanningText': 'Направете или изберете снимка на документа, където краищата са видими и целият текст е ясно четим.',
		'errorNotRecognised': 'Документът не е разпознат',
		'errorWrongType': 'Този документ не е разпознат като {documentType}. Моля, качете правилния документ или ясна снимка на документа.',
		'feedbackReview': 'Временно приет, изчаква проверка',
		'lblCountry': 'Държава',
		'lblExpires': 'Изтича',
		'lblUploadOrCapture': 'Качете или направете снимка',
		'docTypesAny': 'Карта за самоличност или подобна',
		'expiredError': 'Документът е изтекъл или ще изтече твърде скоро',
	},
	'CS': {
		'welcomeTitle': 'Potřebujeme naskenovat nějaké dokumenty',
		'welcomeReason': 'Další stránka vás provede tímto procesem.',
		'scanningTitle': 'Nahrajte své dokumenty',
		'scanningText': 'Pořiďte nebo vyberte obrázek dokumentu, kde jsou okraje viditelné a veškerý text je jasně čitelný.',
		'errorNotRecognised': 'Dokument nerozpoznán',
		'errorWrongType': 'Tento dokument není rozpoznán jako {documentType}. Nahrajte prosím správný dokument nebo jasný obrázek dokumentu.',
		'feedbackReview': 'Předběžně přijato, čeká na kontrolu',
		'lblCountry': 'Země',
		'lblExpires': 'Vyprší',
		'lblUploadOrCapture': 'Nahrát nebo pořídit obrázek',
		'docTypesAny': 'Občanský průkaz nebo podobný',
		'expiredError': 'Dokument vypršel nebo brzy vyprší',
	},
	'DA': {
		'welcomeTitle': 'Vi skal skanne nogle dokumenter',
		'welcomeReason': 'Næste side vil guide dig gennem denne proces.',
		'scanningTitle': 'Upload dine dokumenter',
		'scanningText': 'Tag eller vælg et billede af dit dokument hvor kanterne er synlige og al tekst er tydeligt læsbar.',
		'errorNotRecognised': 'Dokument ikke genkendt',
		'errorWrongType': 'Dette dokument er ikke genkendt som {documentType}. Upload venligst det korrekte dokument eller et klart billede af dokumentet.',
		'feedbackReview': 'Foreløbigt accepteret, afventer gennemgang',
		'lblCountry': 'Land',
		'lblExpires': 'Udløber',
		'lblUploadOrCapture': 'Upload eller tag et billede',
		'docTypesAny': 'ID-kort eller lignende',
		'expiredError': 'Dokument udløbet eller udløber for snart',
	},
	'ES': {
		'welcomeTitle': 'Necesitamos escanear algunos documentos',
		'welcomeReason': 'La siguiente página le guiará a través de este proceso.',
		'scanningTitle': 'Sube tus documentos',
		'scanningText': 'Captura o selecciona una imagen de tu documento donde los bordes sean visibles y todo el texto esté claramente legible.',
		'errorNotRecognised': 'Documento no reconocido',
		'errorWrongType': 'Este documento no se reconoce como {documentType}. Por favor, suba el documento correcto o una imagen clara del documento.',
		'feedbackReview': 'Aceptado provisionalmente, pendiente de revisión',
		'lblCountry': 'País',
		'lblExpires': 'Vence',
		'lblUploadOrCapture': 'Sube o toma una foto',
		'docTypesAny': 'Tarjeta de identidad o similar',
		'expiredError': 'Documento vencido o vencerá demasiado pronto',
	},
	'FI': {
		'welcomeTitle': 'Meidän täytyy skannata joitakin asiakirjoja',
		'welcomeReason': 'Seuraava sivu opastaa sinut tämän prosessin läpi.',
		'scanningTitle': 'Lataa asiakirjasi',
		'scanningText': 'Ota tai valitse kuva asiakirjastasi, jossa reunat ovat näkyvissä ja kaikki teksti on selkeästi luettavissa.',
		'errorNotRecognised': 'Asiakirjaa ei tunnistettu',
		'errorWrongType': 'Tämä asiakirja ei tunnisteta {documentType}ksi. Lataa oikea asiakirja tai selkeä kuva asiakirjasta.',
		'feedbackReview': 'Ehdollisesti hyväksytty, odottaa tarkistusta',
		'lblCountry': 'Maa',
		'lblExpires': 'Vanhenee',
		'lblUploadOrCapture': 'Lataa tai ota kuva',
		'docTypesAny': 'Henkilökortti tai vastaava',
		'expiredError': 'Asiakirja vanhentunut tai vanhenee liian pian',
	},
	'HR': {
		'welcomeTitle': 'Trebamo skenirati neke dokumente',
		'welcomeReason': 'Sljedeća stranica će vas provesti kroz ovaj proces.',
		'scanningTitle': 'Učitajte svoje dokumente',
		'scanningText': 'Snimite ili odaberite sliku vašeg dokumenta gdje su rubovi vidljivi i sav tekst je jasno čitljiv.',
		'errorNotRecognised': 'Dokument nije prepoznat',
		'errorWrongType': 'Ovaj dokument nije prepoznat kao {documentType}. Molimo učitajte ispravan dokument ili jasnu sliku dokumenta.',
		'feedbackReview': 'Uvjetno prihvaćeno, čeka pregled',
		'lblCountry': 'Zemlja',
		'lblExpires': 'Istječe',
		'lblUploadOrCapture': 'Učitaj ili snimi sliku',
		'docTypesAny': 'Osobna iskaznica ili slično',
		'expiredError': 'Dokument je istekao ili će uskoro isteći',
	},
	'HU': {
		'welcomeTitle': 'Szükségünk van néhány dokumentum beolvasására',
		'welcomeReason': 'A következő oldal végigvezeti ezen a folyamaton.',
		'scanningTitle': 'Töltse fel dokumentumait',
		'scanningText': 'Készítsen vagy válasszon egy képet a dokumentumáról, ahol a szélek láthatók és az összes szöveg jól olvasható.',
		'errorNotRecognised': 'Dokumentum nem felismerhető',
		'errorWrongType': 'Ez a dokumentum nem ismerhető fel {documentType}-ként. Kérjük, töltse fel a megfelelő dokumentumot vagy a dokumentum tiszta képét.',
		'feedbackReview': 'Ideiglenesen elfogadva, felülvizsgálatra vár',
		'lblCountry': 'Ország',
		'lblExpires': 'Lejár',
		'lblUploadOrCapture': 'Feltöltés vagy fénykép készítése',
		'docTypesAny': 'Személyi igazolvány vagy hasonló',
		'expiredError': 'Dokumentum lejárt vagy túl hamar le fog járni',
	},
	'IT': {
		'welcomeTitle': 'Dobbiamo scannerizzare alcuni documenti',
		'welcomeReason': 'La pagina seguente ti guiderà attraverso questo processo.',
		'scanningTitle': 'Carica i tuoi documenti',
		'scanningText': 'Cattura o seleziona un\'immagine del tuo documento dove i bordi sono visibili e tutto il testo è chiaramente leggibile.',
		'errorNotRecognised': 'Documento non riconosciuto',
		'errorWrongType': 'Questo documento non è riconosciuto come {documentType}. Carica il documento corretto o un\'immagine chiara del documento.',
		'feedbackReview': 'Accettato provvisoriamente, in attesa di revisione',
		'lblCountry': 'Paese',
		'lblExpires': 'Scade',
		'lblUploadOrCapture': 'Carica o scatta una foto',
		'docTypesAny': 'Carta d\'identità o simile',
		'expiredError': 'Documento scaduto o scadrà troppo presto',
	},
	'NO': {
		'welcomeTitle': 'Vi må skanne noen dokumenter',
		'welcomeReason': 'Neste side vil guide deg gjennom denne prosessen.',
		'scanningTitle': 'Last opp dokumentene dine',
		'scanningText': 'Ta eller velg et bilde av dokumentet ditt hvor kantene er synlige og all tekst er tydelig lesbar.',
		'errorNotRecognised': 'Dokument ikke gjenkjent',
		'errorWrongType': 'Dette dokumentet er ikke gjenkjent som {documentType}. Last opp riktig dokument eller et klart bilde av dokumentet.',
		'feedbackReview': 'Foreløpig akseptert, venter på gjennomgang',
		'lblCountry': 'Land',
		'lblExpires': 'Utløper',
		'lblUploadOrCapture': 'Last opp eller ta et bilde',
		'docTypesAny': 'ID-kort eller lignende',
		'expiredError': 'Dokument utløpt eller vil utløpe for snart',
	},
	'PT': {
		'welcomeTitle': 'Precisamos escanear alguns documentos',
		'welcomeReason': 'A próxima página o guiará por este processo.',
		'scanningTitle': 'Faça upload dos seus documentos',
		'scanningText': 'Capture ou selecione uma imagem do seu documento onde as bordas estão visíveis e todo o texto está claramente legível.',
		'errorNotRecognised': 'Documento não reconhecido',
		'errorWrongType': 'Este documento não é reconhecido como {documentType}. Por favor, carregue o documento correto ou uma imagem clara do documento.',
		'feedbackReview': 'Aceito provisoriamente, aguardando revisão',
		'lblCountry': 'País',
		'lblExpires': 'Expira',
		'lblUploadOrCapture': 'Carregar ou tirar uma foto',
		'docTypesAny': 'Carteira de identidade ou similar',
		'expiredError': 'Documento expirado ou expirará muito em breve',
	},
	'RO': {
		'welcomeTitle': 'Trebuie să scanezim câteva documente',
		'welcomeReason': 'Următoarea pagină vă va ghida prin acest proces.',
		'scanningTitle': 'Încărcați documentele',
		'scanningText': 'Captați sau selectați o imagine a documentului dvs. unde marginile sunt vizibile și tot textul este clar lizibil.',
		'errorNotRecognised': 'Document nerecunoscut',
		'errorWrongType': 'Acest document nu este recunoscut ca {documentType}. Vă rugăm să încărcați documentul corect sau o imagine clară a documentului.',
		'feedbackReview': 'Acceptat provizoriu, în așteptarea revizuirii',
		'lblCountry': 'Țară',
		'lblExpires': 'Expiră',
		'lblUploadOrCapture': 'Încărcați sau faceți o fotografie',
		'docTypesAny': 'Carte de identitate sau similar',
		'expiredError': 'Document expirat sau va expira prea curând',
	},
	'RU': {
		'welcomeTitle': 'Нам нужно отсканировать документы',
		'welcomeReason': 'Следующая страница проведет вас через этот процесс.',
		'scanningTitle': 'Загрузите ваши документы',
		'scanningText': 'Сделайте или выберите изображение вашего документа, где края видны и весь текст четко читаем.',
		'errorNotRecognised': 'Документ не распознан',
		'errorWrongType': 'Этот документ не распознан как {documentType}. Пожалуйста, загрузите правильный документ или четкое изображение документа.',
		'feedbackReview': 'Временно принят, ожидает проверки',
		'lblCountry': 'Страна',
		'lblExpires': 'Истекает',
		'lblUploadOrCapture': 'Загрузить или сделать фото',
		'docTypesAny': 'Удостоверение личности или подобное',
		'expiredError': 'Документ истек или скоро истечет',
	},
	'SK': {
		'welcomeTitle': 'Musíme naskenovať nejaké dokumenty',
		'welcomeReason': 'Ďalšia stránka vás prevedie týmto procesom.',
		'scanningTitle': 'Nahrajte svoje dokumenty',
		'scanningText': 'Zhotovte alebo vyberte obrázok dokumentu, kde sú okraje viditeľné a všetok text je jasne čitateľný.',
		'errorNotRecognised': 'Dokument nebol rozpoznaný',
		'errorWrongType': 'Tento dokument nie je rozpoznaný ako {documentType}. Nahrajte správny dokument alebo jasný obrázok dokumentu.',
		'feedbackReview': 'Predbežne akceptovaný, čaká na kontrolu',
		'lblCountry': 'Krajina',
		'lblExpires': 'Vyprší',
		'lblUploadOrCapture': 'Nahrať alebo urobiť obrázok',
		'docTypesAny': 'Občiansky preukaz alebo podobný',
		'expiredError': 'Dokument vypršal alebo vyprší príliš skoro',
	},
	'SI': {
		'welcomeTitle': 'Skenirati moramo nekatere dokumente',
		'welcomeReason': 'Naslednja stran vas bo popeljevala skozi ta postopek.',
		'scanningTitle': 'Naložite svoje dokumente',
		'scanningText': 'Ustvarite ali izberite sliko dokumenta, kjer so robovi vidni in ves tekst jasno berljiv.',
		'errorNotRecognised': 'Dokument ni prepoznan',
		'errorWrongType': 'Ta dokument ni prepoznan kot {documentType}. Prosimo, naložite pravilen dokument ali jasno sliko dokumenta.',
		'feedbackReview': 'Začasno sprejeto, čaka na pregled',
		'lblCountry': 'Država',
		'lblExpires': 'Izteče',
		'lblUploadOrCapture': 'Naložite ali naredite fotografijo',
		'docTypesAny': 'Osebna izkaznica ali podobno',
		'expiredError': 'Dokument je potekel ali bo kmalu potekel',
	},
	'SV': {
		'welcomeTitle': 'Vi behöver skanna några dokument',
		'welcomeReason': 'Nästa sida kommer att guida dig genom denna process.',
		'scanningTitle': 'Ladda upp dina dokument',
		'scanningText': 'Fånga eller välj en bild av ditt dokument där kanterna är synliga och all text är tydligt läsbar.',
		'errorNotRecognised': 'Dokument inte igenkänt',
		'errorWrongType': 'Detta dokument känns inte igen som {documentType}. Ladda upp korrekt dokument eller en tydlig bild av dokumentet.',
		'feedbackReview': 'Villkorligt godkänd, väntar på granskning',
		'lblCountry': 'Land',
		'lblExpires': 'Förfaller',
		'lblUploadOrCapture': 'Ladda upp eller ta en bild',
		'docTypesAny': 'ID-kort eller liknande',
		'expiredError': 'Dokumentet har utgått eller kommer att gå ut för snart',
	},
	'TR': {
		'welcomeTitle': 'Bazı belgeleri taramamız gerekiyor',
		'welcomeReason': 'Sonraki sayfa size bu süreçte rehberlik edecektir.',
		'scanningTitle': 'Belgelerinizi yükleyin',
		'scanningText': 'Kenarların görünür olduğu ve tüm metnin açıkça okunabilir olduğu belgenizin bir görüntüsünü çekin veya seçin.',
		'errorNotRecognised': 'Belge tanınmadı',
		'errorWrongType': 'Bu belge {documentType} olarak tanınmadı. Lütfen doğru belgeyi veya belgenin net bir görüntüsünü yükleyin.',
		'feedbackReview': 'Geçici olarak kabul edildi, inceleme bekleniyor',
		'lblCountry': 'Ülke',
		'lblExpires': 'Doluyor',
		'lblUploadOrCapture': 'Yükle veya fotoğraf çek',
		'docTypesAny': 'Kimlik kartı veya benzeri',
		'expiredError': 'Belge süresi dolmuş veya çok yakında dolacak',
	},
	'UK': {
		'welcomeTitle': 'Нам потрібно відсканувати документи',
		'welcomeReason': 'Наступна сторінка проведеть вас через цей процес.',
		'scanningTitle': 'Завантажте ваші документи',
		'scanningText': 'Зробіть або виберіть зображення вашого документа, де краї видні і весь текст чітко читається.',
		'errorNotRecognised': 'Документ не розпізнано',
		'errorWrongType': 'Цей документ не розпізнано як {documentType}. Будь ласка, завантажте правильний документ або чітке зображення документа.',
		'feedbackReview': 'Тимчасово прийнято, очікує перевірки',
		'lblCountry': 'Країна',
		'lblExpires': 'Закінчується',
		'lblUploadOrCapture': 'Завантажити або зробити фото',
		'docTypesAny': 'Посвідчення особи або подібне',
		'expiredError': 'Документ закінчився або скоро закінчиться',
	}
};

export function getTextDefaults(lang) {
	return textDefaults[lang.toUpperCase()] || textDefaults['EN'];
}

export function getLanguages() {
	return Object.keys(textDefaults);
}
